import * as React from "react";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import { AuthClientTokens } from "@react-keycloak/core";
import keycloak from "./keycloack";
import { KeycloakLoader } from "./KeycloakLoader";
import { useAppDispatch } from "../../hooks/redux";
import { userSlice } from "../../store/reducers/userSlice";
import { AppLocalStorage } from "../../utils/localStorage";

type TKeycloakProvider = {
  children: React.ReactNode;
};

export const KeycloakProvider = ({ children }: TKeycloakProvider) => {
  const dispatch = useAppDispatch();
  const { setToken } = userSlice.actions;
  const onTokens = (tokens: AuthClientTokens) => {
    AppLocalStorage.setLSToken(tokens.token || "123");
    dispatch(setToken(tokens.token));
  };

  return (
    <ReactKeycloakProvider
      initOptions={{
        onLoad: "login-required",
        checkLoginIframe: true,
      }}
      onTokens={onTokens}
      LoadingComponent={<KeycloakLoader />}
      authClient={keycloak}
    >
      {children}
    </ReactKeycloakProvider>
  );
};
